import icons from "../constants/categoryIcons";

export const qsList = [
  {
    id: 1,
    data: {
      question: "Build your skincare steps for free.",
      value: "",
    },
    type: "landing",
    btnLabel: "Next",
  },
  {
    id: 2,
    data: {
      question: "Awesome! Now pick your skincare vibe:",
      value: "",
    },
    options: [
      {
        label: "I'm lost in the skincare aisle—send help!",
        value: "I'm lost in the skincare aisle—send help!",
      },
      {
        label: "My skin’s got concerns, and I need answers",
        value: "My skin’s got concerns, and I need answers",
      },
      {
        label: "Just curious what else I could be doing",
        value: "Just curious what else I could be doing",
      },
      {
        label: "Keep it chill— I want something easy",
        value: "Keep it chill— I want something easy",
      },
    ],
    type: "multiple",
    required: "multiple",
  },
  {
    id: 3,
    data: {
      question: "What kind of skincare do you prefer?",
      value: "skincare preference",
    },
    options: [
      "Natural/ Organic/ Clean",
      "Cruelty free/ Vegan",
      "Clinical/ Medical Brands",
      "Pregnancy / Breastfeeding safe",
      "Grooming / Shaving Safe",
      "Prefer products with aroma",
      "Prefer unscented products",
      "Time saving multi-task products",
    ],
    type: "multiple",
    required: "multiple",
  },
  {
    id: 4,
    data: {
      question: "Which skincare are you looking to buy?",
      value: "",
    },
    instruction: "(Only select what you need.)",
    type: "multiple with image",
    required: "multiple",
    options: {
      basic: [
        {
          id: 1,
          name: "Cleanser",
          image: icons["cleanser"],
        },
        {
          id: 2,
          name: "Treatment",
          image: icons["treatment"],
        },
        {
          id: 3,
          name: "Serum",
          image: icons["serum"],
        },
        {
          id: 4,
          name: "Moisturizer",
          image: icons["moisturizer"],
        },
        {
          id: 5,
          name: "Sunscreen",
          image: icons["sunscreen"],
        },
      ],
      savvy: [
        {
          id: 1,
          name: "Makeup Remover",
          image: icons["makeup remover"],
        },
        {
          id: 21,
          name: "Toner",
          image: icons["toner"],
        },
        {
          id: 2,
          name: "Exfoliator",
          image: icons["exfoliator"],
        },
        {
          id: 3,
          name: "Face Oil",
          image: icons["face oil"],
        },
        {
          id: 4,
          name: "Face Mask",
          image: icons["mask"],
        },
        {
          id: 5,
          name: "EyeCream",
          image: icons["eye cream"],
        },
      ],
    },
  },
  {
    id: 5,
    question: "What's your price range for skincare?",
    data: {
      question: "What's your price range for skincare?",
      value: "price range",
    },
    type: "multiple radio",
    labels: ["$10~$20", "$21~$35", "$36~$60", "$61~$100", "$101+"],
  },
  {
    id: 6,
    data: {
      question: "Where do you like to shop your new skincare products?",
      value: "Where to Shop",
    },
    instruction: "(Select your 1st, 2nd, and 3rd choice)",
    options: [
      "Brand’s Website",
      "Sephora",
      "Amazon",
      "Target",
      "Ulta",
      "Walmart",
      "Nordstorm",
      "Bloomingdales",
      "Dermstore",
      "Walgreens",
      "CVS Pharmacy",
      "Other",
    ],
    type: "skin concern type",
    subType: "jumpMultiple",
  },
  {
    id: 7,
    data: {
      label: "Next is about your current skincare.",
      value: "",
    },
    type: "roadblock",
  },
  {
    id: 8,
    data: {
      question: "What skincare are you currently using?",
      value: "",
    },
    options: [
      {
        time: "Morning",
        productType: [
          {
            title: "Cleanser",
            subTitle: "",
          },
          {
            title: "Toner",
            subTitle: "",
          },
          {
            title: "Serum",
            subTitle: "",
          },
          {
            title: "Moisturizer",
            subTitle: "",
          },
          {
            title: "Sunscreen",
            subTitle: "",
          },
          {
            title: "Other1",
            subTitle: "",
          },
          {
            title: "Other2",
            subTitle: "",
          },
          {
            title: "Other3",
            subTitle: "",
          },
        ],
      },
      {
        time: "Night",
        productType: [
          {
            title: "Cleanser",
            subTitle: "",
          },
          {
            title: "Toner",
            subTitle: "",
          },
          {
            title: "Serum",
            subTitle: "",
          },
          {
            title: "Moisturizer",
            subTitle: "",
          },
          {
            title: "Eye Cream",
            subTitle: "",
          },
          {
            title: "Facial Treatment",
            subTitle: "(Eg: AHA, BHA, retinol)",
          },
          {
            title: "Makeup Remover",
            subTitle: "",
          },
          {
            title: "Face Oil",
            subTitle: "",
          },
          {
            title: "Face Mask",
            subTitle: "",
          },
          {
            title: "Exfoliator",
            subTitle: "(Eg: enzymes, scrubs)",
          },
          {
            title: "Other1",
            subTitle: "",
          },
          {
            title: "Other2",
            subTitle: "",
          },
        ],
      },
    ],
    type: "routine question",
    required: "routine",
  },
  {
    id: 9,
    data: {
      question:
        "Which products do you like to keep using from current skincare?",
      value: "which like to keep using",
    },
    options: [
      "I want to swap all of my skincare.",
      "I like to keep using these skincare.",
    ],
    placeholder: "Share your favorites here",
    type: "single option with input",
    inputType: "select",
    required: "single",
  },
  {
    id: 10,
    data: {
      question: "Why do you want to swap these products?",
      value: "",
    },
    type: "multiple checkbox",
    options: ["Too Expensive", "No Satisfied", "Finished", "Bored! Try New"],
  },
  {
    id: 11,
    data: {
      question:
        "How comfortable are you with exfoliating treatments like AHA, BHA, Retinol, Tretinoin?",
      value: "",
    },
    options: [
      {
        label: "Very comfortable. Have been using it for a while.",
        value: "Advanced",
      },
      {
        label: "Okay comfortable. On and off using it.",
        value: "Intermediate",
      },
      {
        label: "Not comfortable. Haven’t used it at all.",
        value: "Beginner",
      },
      {
        label: "I don’t know what are these treatments.",
        value: "Beginner",
      },
    ],
    type: "single",
    required: "single",
  },
  {
    id: 12,
    data: {
      label: "Last is all about your skin.",
      value: "",
    },
    type: "roadblock",
  },
  {
    id: 13,
    data: {
      question: "When you wake up in the morning how does your skin feel?",
      value: "skin type",
    },
    options: [
      "Dry, tight and uncomfortable",
      "Only some parts are oily",
      "Normal. Not too oily or dry",
    ],
    type: "multiple",
    required: "multiple",
  },
  {
    id: 14,
    data: {
      question: "As the day goes by how does your skin feel?",
      value: "skin feel during the day?",
    },
    options: [
      {
        label: "Starts getting drier",
        value: "Dry Skin",
      },
      {
        label: "Starts getting a little oily",
        value: "Combination Skin",
      },
      {
        label: "Starts getting shiny",
        value: "Oily Skin",
      },
      {
        label: "Fine. Neither oily nor dry",
        value: "Normal Skin",
      },
    ],
    type: "single",
    required: "single",
  },
  {
    id: 15,
    data: {
      question: "How frequently do you get acne or breakout?",
      value: "",
    },
    options: [
      "Never",
      "Not very often",
      "Often or hormonally",
      "Very frequently",
    ],
    type: "single",
    required: "single",
  },
  {
    id: 16,
    data: {
      question: "On a scale of 1-5, how sensitive is your skin?",
      value: "",
    },
    options: ["None", "Very rare", "Sometimes", "Often", "Most of the time"],
    type: "single with number",
    required: "single",
  },
  {
    id: 17,
    data: {
      question: "What does your skin sensitivity look like? ",
      value: "",
    },
    options: [
      "Redness",
      "Dry/ flaky patches",
      "Burning or itching sensation",
      "Medical condition (eg. eczema, dermatitis, rosacea)",
    ],
    type: "jumpMultiple",
    required: "multiple",
  },
  {
    id: 18,
    data: {
      question: "What are your main skin concerns?",
      value: "",
    },
    options: [
      "Acne",
      "Redness",
      "Fine lines & wrinkles",
      "Dark spot/Acne scars",
      "Oiliness",
      "Loss of firmness",
      "Dark Circle",
      "Uneven skin tone",
      "Uneven skin texture",
      "Clogged Pores",
      "Dullness",
      "Dryness",
    ],
    type: "skin concern type",
    subType: "jumpMultiple",
  },
  {
    id: 19,
    data: {
      question:
        "Your skin needs extra care depending on the weather, where do you live?",
      value: "",
    },
    type: "single input",
    name: "zipcode",
    validation: [{ required: true, message: "You have to enter your zipcode" }],
    placeholder: "Enter your zipcode",
  },
  {
    id: 20,
    data: {
      question: "Anything else we should know about your skin or preferences?",
      value: "Client extra skin preference",
    },
    type: "extra_information",
  },
  {
    id: 21,
    data: {
      question: "Share your recent photo for our assessment.",
      value: "",
    },
    type: "photo upload",
  },
  {
    id: 22,
    data: {
      question: "Check-in",
      value: "",
    },
    type: "personal information",
  },
  // {
  //   question: "When you wake up in the morning how does your skin feel?",
  //   options: [
  //     {
  //       label: "Dry, tight and uncomfortable",
  //       value: "Dry, tight and uncomfortable",
  //     },
  //     {
  //       label: "Only some parts are oily",
  //       value: "Only some parts are oily",
  //     },
  //     {
  //       label: "Normal. Not too oily or dry",
  //       value: "Normal. Not too oily or dry",
  //     },
  //   ],
  //   type: "multiple",
  //   required: "multiple",
  // },
  // {
  //   question: "When you wake up in the morning how does your skin feel?",
  //   options: [
  //     {
  //       label: "Starts getting drier.",
  //       value: "Dry Skin",
  //     },
  //     {
  //       label: "Starts getting a little oily.",
  //       value: "Combination Skin",
  //     },
  //     {
  //       label: "Starts getting shiny.",
  //       value: "Oily Skin",
  //     },
  //     {
  //       label: "Fine. Neither oily nor dry",
  //       value: "Normal Skin",
  //     },
  //   ],
  //   type: "single",
  //   required: "single",
  // },

  // {
  //   question: "Age can shape your skin’s need. What is your age?",
  //   type: "single input",
  //   name: "age",
  //   validation: [{ required: true, message: "You have to age" }],
  //   placeholder: "Age",
  // },

  // {
  //   question: "...and your gender?",
  //   options: [
  //     {
  //       label: "Women",
  //       value: "Women",
  //     },
  //     { label: "Man", value: "Man" },
  //     {
  //       label: "Non binary / Gender diverse",
  //       value: "Non binary / Gender diverse",
  //     },
  //     {
  //       label: "Prefer not to say",
  //       value: "Prefer not to say",
  //     },
  //     {
  //       label: "Prefer to self describe",
  //       value: "Prefer to self describe",
  //     },
  //   ],
  //   type: "single",
  //   required: "single",
  // },
  // {
  //   question:
  //     "Hi There! Share your skincare. We'll build a precise routine for you.",
  //   noInstruction: true,
  //   options: [
  //     "I'll share the products I've used before.",
  //     "I'll share the products I'm currently using.",
  //   ],
  //   subTextOptions: [
  //     "(New skincare routine will be build)",
  //     "(Synergistic skincare routine will be build)",
  //   ],
  //   type: "single",
  //   required: "single",
  //   hasVideoPlayback: true,
  // },
  // {
  //   title: "Next is all about your skincare preference.",
  //   type: "roadblock",
  // },
  // {
  //   question: "What kind of skincare steps do you like? ",
  //   options: [
  //     "Quick with 2-3 products",
  //     "Simple with 4-5 products",
  //     "Go all in with 10 steps routine",
  //     "Open to the best suggestion.",
  //   ],
  //   type: "single",
  //   required: "single",
  // },
  // {
  //   question: "How much do you usually spend on a skincare product?",
  //   options: ["$10 - $25", "$26 - $50", "$51 - $110", "$110+"],
  //   type: "single",
  //   required: "single",
  // },

  // {
  //   question: "How much time do you spend under the sun?",
  //   options: [
  //     "I am indoors most of the time",
  //     "Mostly on weekends, I am outdoor",
  //     "A lot of outdoor activities",
  //     "Other",
  //   ],
  //   placeholder: "",
  //   type: "single option with input",
  //   required: "single",
  // },

  // {
  //   question: "What’s your gender?",
  //   options: ["Woman", "Man", "Non Binary", "Prefer not to say"],
  //   type: "single",
  //   required: "single",
  // },

  // {
  //   title: "Next is a fun part. It's about your current product.",
  //   type: "roadblock",
  // },
];
